<script setup lang="ts">
import { ref } from "vue";
import ToolTip from "../../ToolTip.vue";
import { locale } from "../../../locale";
import { usersState } from "../../../states/usersState";
import { toggleUserList, viewState } from "../../../states/viewState";
import { handsUpUsers } from "../../../states/handUpState";
import { usersInWaitRoom } from "../../../states/waitRoomState";
import { isSelfAdmin } from "../../../states/adminsState";

const btn = ref<HTMLElement | null>(null);
</script>
<template>
  <button
    ref="btn"
    class="users-button"
    @click="toggleUserList"
    :class="{
      active: viewState.rightBlockContent === 'users',
    }"
  >
    <div
      class="users-alert"
      v-if="
        handsUpUsers.length > 0 || (isSelfAdmin && usersInWaitRoom.length > 0)
      "
    ></div>
    <svg
      class="users-ico"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8896 8.17109C16.8896 10.824 14.7092 12.9906 11.9998 12.9906C9.29036 12.9906 7.11003 10.824 7.11003 8.17109C7.11003 5.51818 9.29036 3.35156 11.9998 3.35156C14.7092 3.35156 16.8896 5.51818 16.8896 8.17109ZM6.0022 19.301C5.779 19.1535 5.68086 19.0507 5.64652 19.012C5.64457 18.9898 5.64248 18.9544 5.64258 18.9032C5.64284 18.7696 5.65738 18.5871 5.68977 18.3648C5.75432 17.9215 5.88134 17.3765 6.05559 16.8491C6.23193 16.3154 6.44307 15.8413 6.65972 15.5167C6.83218 15.2584 6.93605 15.1984 6.95506 15.1865C7.20772 15.1957 7.49188 15.3171 8.05708 15.5886L8.06228 15.5911C8.92559 16.0057 10.118 16.5783 11.9996 16.5783C13.8813 16.5783 15.0737 16.0057 15.937 15.5911L15.9422 15.5886C16.5074 15.3171 16.7916 15.1957 17.0442 15.1865C17.0633 15.1984 17.1671 15.2585 17.3394 15.5167C17.5561 15.8412 17.7671 16.3153 17.9434 16.849C18.1176 17.3764 18.2446 17.9215 18.3091 18.3647C18.3415 18.5871 18.356 18.7695 18.3563 18.9032C18.3564 18.9544 18.3543 18.9898 18.3524 19.0121C18.318 19.0507 18.22 19.1536 17.9968 19.3011C17.7103 19.4904 17.2904 19.7055 16.736 19.9078C15.63 20.3113 14.0336 20.6478 11.9996 20.6478C9.96574 20.6478 8.36923 20.3113 7.26313 19.9078C6.70869 19.7055 6.28872 19.4904 6.0022 19.301Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </svg>
    <span class="count">{{ usersState.users.length }}</span>
    <ToolTip :placement="'top'" :reference="btn">{{
      isSelfAdmin ? locale.usersettings : locale.userlist
    }}</ToolTip>
  </button>
  <!-- <PopoverUserList :reference="btn" /> -->
</template>
<style lang="scss" scoped>
.users-button {
  width: 60px;
  position: relative;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: var(--bottom-btn-off-bg-regular);
  backdrop-filter: blur(2px);
  border-radius: 36px;
  border: none;
  cursor: pointer;

  & svg {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    color: var(--bottom-btn-off-content-regular);
  }

  & .count {
    min-width: 18px;
    text-align: center;
  }

  &:hover {
    background-color: var(--bottom-btn-off-bg-hover);
    & svg {
      color: var(--bottom-btn-off-content-hover);
    }
  }

  &:active {
    background-color: var(--bottom-btn-off-bg-active);
    & svg {
      color: var(--bottom-btn-off-content-active);
    }
  }

  &:focus {
    outline: none;
  }
}

.users-button.active {
  background-color: var(--bottom-btn-on-bg-regular);

  & .count {
    color: rgba(41, 41, 41, 1);
  }

  & svg {
    color: var(--bottom-btn-on-content-regular);
  }

  &:hover {
    background-color: var(--bottom-btn-on-bg-hover);
    & svg {
      color: var(--bottom-btn-on-content-hover);
    }
  }

  &:active {
    background-color: var(--bottom-btn-on-bg-active);
    & svg {
      color: var(--bottom-btn-on-content-active);
    }
  }
}

.users-alert {
  position: absolute;
  width: 12px;
  height: 12px;
  top: 0;
  right: 0;
  background-color: var(--marker-alert-color);
  border-radius: 50%;
}

.count {
  color: var(--White, #fff);
  text-align: center;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>
